import { Account } from '@/domain/usecases'
import { lazy, ReactNode } from 'react'

const DashboardPage = lazy(() => import('@pages/company-manager/dashboard/dashboard-page'))

export const makeDashboardPage = (): ReactNode => {
  return <DashboardPage />
}

const CreateUserProfilePage = lazy(
  () => import('@/presentation/pages/company-manager/create-user-profile/create-user-profile-page')
)

export const makeCreateUserProfilePage = (): ReactNode => {
  return <CreateUserProfilePage />
}

const EditUserProfilePage = lazy(
  () => import('@/presentation/pages/company-manager/edit-user-profile/edit-user-profile-page')
)

export const makeEditUserProfilePage = (): ReactNode => {
  return <EditUserProfilePage />
}

const HolderSearchPage = lazy(
  () => import('@pages/company-manager/dependent/holder-search/holder-search-page')
)

export const makeDependentHolderSearchPage = (accountProfile: Account.Model): ReactNode => {
  return <HolderSearchPage accountProfile={accountProfile} />
}

const DependentRegistrationPage = lazy(
  () =>
    import(
      '@/presentation/pages/company-manager/dependent/dependent-registration/dependent-registration-page'
    )
)

export const makeDependentRegistrationPage = (): ReactNode => {
  return <DependentRegistrationPage />
}

const DependentSearchPage = lazy(
  () =>
    import('@/presentation/pages/company-manager/dependent/dependent-search/dependent-search-page')
)

export const makeDependentSearchPage = (): ReactNode => {
  return <DependentSearchPage />
}

const RequestsConfigurationPage = lazy(
  () =>
    import(
      '@/presentation/pages/company-manager/requests/requests-configuration/requests-configuration-page'
    )
)

export const makeRequestsConfigurationPage = (): ReactNode => {
  return <RequestsConfigurationPage />
}

const DependentEnrollmentPage = lazy(
  () =>
    import(
      '@/presentation/pages/company-manager/dependent/dependent-enrollment/dependent-enrollment-page'
    )
)

export const makeDependentEnrollmentPage = (): ReactNode => {
  return <DependentEnrollmentPage />
}

const UpgradeEnrollmentPage = lazy(
  () =>
    import(
      '@/presentation/pages/company-manager/upgrade/upgrade-enrollment/upgrade-enrollment-page'
    )
)

export const makeUpgradeEnrollmentPage = (): ReactNode => {
  return <UpgradeEnrollmentPage />
}
